import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { userRoles } from '../../constants';

const UsersTableMobile = ({ users }) => {
  return (
    <div className="cases-table-mobile">
      {users.map((user) => {

        return (
          <div key={user.uid} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{`${user.firstName} ${user.lastName}`}</div>
              <div className="d-flex flex-end">{userRoles[user.role]?.label}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {user.email}
              </div>
              <div className="secondary">
                {user.phone}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

UsersTableMobile.propTypes = {
  users: PropTypes.array,
};

export default memo(UsersTableMobile);
